<script lang="ts">
	import { PUBLIC_STRAPI_MEDIA } from '$env/static/public'
	import { page } from '$app/stores'
	import { is_set_object } from '$lib/js/helpers'
	import type { PromoBanner } from '$lib/js/strapi/types'
	import { getContextScope } from '$lib/js/helpers/i18n'

	let banners: Array<PromoBanner> = $page.data?.promo_banner
	const scope = getContextScope()
	const today = new Date().toISOString().split('T')[0]

	$: img_size =	$page.data.mobile === true ? { width: 350, height: 200 } : { width: 1100, height: 200 }

	const isValidDate = (doc) =>
		(!doc.start_date || today >= doc.start_date) && (!doc.end_date || today <= doc.end_date)

	const matchCategory = (doc) => {
		if (!doc.cat_id) return false
		const categoryIds = doc.cat_id.split(',')
		return $page.data.category?.path.split('/').some((val) => categoryIds.includes(val))
	}

	// Step 1: If no banner found, try category match
  let display_banner: PromoBanner | undefined = banners?.find(
		(doc) => matchCategory(doc) && isValidDate(doc)
	)

	// Step 2: If still no banner, try `is_main` banner
	if (!is_set_object(display_banner)) {
		display_banner = banners?.find((doc) => doc.is_main === true && isValidDate(doc))
	}

	// Step 3: Final fallback - pick the first valid banner
	if (!is_set_object(display_banner)) {
		display_banner = banners?.find(isValidDate)
	}
</script>

{#if display_banner && display_banner.cat_img_mobile?.url}
	<div class="container">
		<div class="category-promo">
			{#if display_banner?.banner_link}
				<a class="product-banner" href="/{scope}{display_banner.banner_link}">
					<picture class="special-banner">
						<source
							srcset="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img.url}"
							media="(min-width: 1200px)"
						/>
						<source
							srcset="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img.url}"
							media="(min-width: 550px)"
						/>
						<img
							src="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img_mobile.url}"
							alt={display_banner.alt_text}
							title={display_banner.alt_text}
							width={img_size?.width}
							height={img_size?.height}
						/>
					</picture>
				</a>
			{:else}
				<picture class="special-banner">
					<source
						srcset="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img.url}"
						media="(min-width: 1200px)"
					/>
					<source
						srcset="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img.url}"
						media="(min-width: 550px)"
					/>
					<img
						src="{PUBLIC_STRAPI_MEDIA}{display_banner.cat_img_mobile.url}"
						alt={display_banner.alt_text}
						title={display_banner.alt_text}
						width={img_size?.width}
						height={img_size?.height}
					/>
				</picture>
			{/if}
		</div>
	</div>
{/if}

<style lang="scss">
	.category-promo {
		margin-top: 40px;

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
